import React from 'react';
import { IConnectedPage } from '../../../types/api/connectedPages/IConnectedPage';
import { ContactPersonsFilter } from './ContactPersonsFilter';
import { FilterLink } from '../../../_lib/components/SelectLinks/SelectLinks';
import { isEmptyArray, isNullOrUndefined } from '../../../lib/typeGuards';
import ContentMessage from '../../../_lib/components/ContentMessage/ContentMessage';
import { ConnectedPagesTree } from '../../../_lib/components/ConnectedPages';
import { useSonTranslation } from '../../../translation/useSonTranslation';
import { PageTypesFilter } from './PageTypesFilter';
import { RolesFilter } from './RolesFilter';
import { ConnectedPagesTreeModifier } from '../../../_lib/components/ConnectedPages/ConnectedPagesTree/ConnectedPagesTree';

export type PageTreeWithFilters = {
  connectedPages?: IConnectedPage[];
  additionalContent?: ContactPersonsFilter[];
  pageTypes?: FilterLink[];
  roles?: FilterLink[];
  eocCounterModifier?: boolean;
};

export function PageTreeWithFilters(props: PageTreeWithFilters) {
  const { t } = useSonTranslation('StructuralPageToPage');

  const getComponent = () => {
    if (isNullOrUndefined(props.connectedPages)) {
      return <ContentMessage text={t('noConnectedPages')} />;
    }
    if (
      isEmptyArray(props.connectedPages) ||
      (props.connectedPages[0].childPages && isEmptyArray(props.connectedPages[0].childPages))
    ) {
      return <ContentMessage text={t('filter.noResults')} />;
    }
    return (
      <ConnectedPagesTree
        connectedPages={props.connectedPages[0].childPages}
        initialVisibleDepth={1}
        modifier={props.eocCounterModifier ? ConnectedPagesTreeModifier.COUNTER : undefined}
      />
    );
  };

  return (
    <>
      {props.additionalContent || props.pageTypes || props.roles ? (
        <div className="structural-page-to-page-tree__filters">
          {props.additionalContent?.length && <ContactPersonsFilter contactPersons={props.additionalContent} />}
          {props.pageTypes?.length && <PageTypesFilter pageTypes={props.pageTypes} />}
          {props.roles?.length && <RolesFilter roles={props.roles} />}
        </div>
      ) : null}
      {getComponent()}
    </>
  );
}
